export const Items: {[k: string]: ModdedItemData} = {
	kommoniumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	lunaliumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	lycaniumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	mimikiumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	solganiumz: {
		inherit: true,
		isNonstandard: "Future",
	},
	ultranecroziumz: {
		inherit: true,
		isNonstandard: "Future",
	},
};
